import { APIPath } from '../constants';
import { CRUDService } from './crud.ts';

class PackagingMaterials extends CRUDService {
  constructor() {
    super(APIPath.packagingMaterials);
  }
}

const PackagingMaterialService = new PackagingMaterials();
Object.freeze(PackagingMaterialService);
export { PackagingMaterialService };
